import React, { useState } from "react";
import Modal from "../../../../components/Reusable/Modal";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import {
  deleteAirtimeProvider,
  fetchAirtimeProviders,
} from "../../../../features/auth/store/airtimeProviderSlice";
import { toast } from "react-toastify";
import { DeleteModalProps } from "../types";
import { RootState } from "../../../../redux/store";
export const DeleteAirtimeProviderModal: React.FC<DeleteModalProps> = ({
  id: providerId,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { currentPage } = useAppSelector(
    (state: RootState) => state.airtimeProviders,
  );

  const handleDelete = async () => {
    if (providerId === null) return;
    setIsSubmitting(true);
    try {
      await dispatch(deleteAirtimeProvider(providerId)).unwrap();
      toast.success("Airtime Provider deleted successfully! 🚀");
      onClose();
      dispatch(fetchAirtimeProviders({ page: currentPage }));
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete provider");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto"
    >
      <h2 className="text-lg md:text-xl font-bold mb-6">
        Delete Airtime Provider
      </h2>
      <div className="space-y-6 p-4">
        <p className="text-base font-semibold mb-4 text-gray-600 dark:text-gray-300">
          Are you sure you want to delete this airtime provider?
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 sm:py-2 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-gray-200 font-medium transition-colors"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="flex-1 px-4 py-3 sm:py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium transition-colors"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
